import { render, staticRenderFns } from "./learning-page-hero-controller.vue?vue&type=template&id=72dc7ab4&"
import script from "./learning-page-hero-controller.vue?vue&type=script&lang=js&"
export * from "./learning-page-hero-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports